module.exports = __webpack_public_path__ + "img/documentsinactive.7428723e.svg";